import {createAsyncAction, createStandardAction} from "typesafe-actions";
import {ErrorResponse} from "../common/types";
import {
    ICategory,
    ILevelGameState,
    ILevelMapAggregatedTile,
    ILevelMapStats,
    ILevelMapTileProgress
} from "./types";
import {SceneryType} from "../settings/SceneryType";

export const startLevel = createStandardAction('@game/START_LEVEL')<{
    level: number,
    scenery: SceneryType
}>();

export const setLevelProgress = createStandardAction('@game/SET_PROGRESS')<{
    isExitFound?: boolean;
    isCompleted?: boolean;
    allTilesAreRevealed?: boolean;
    levelProgress: Record<number, ILevelMapTileProgress>
}>();

export const completeLevel = createStandardAction('@game/COMPLETE_LEVEL')<ILevelMapStats>();

export const openTile = createStandardAction('@game/OPEN_TILE')<ILevelMapAggregatedTile>();
export const revealTile = createStandardAction('@game/REVEAL_TILE')<ILevelMapAggregatedTile>();

export const setQuestion = createStandardAction('@game/USE_QUESTION')<number>();
export const replaceQuestion = createStandardAction('@game/REPLACE_QUESTION')<{ current: number, replaceWith: number }>();

export const incrementScoreMultiplier = createStandardAction('@game/INCREMENT_SCORE_MULTIPLIER')();

export const fetchLevelMap = createAsyncAction(
    '@game/FETCH_LEVEL_REQUEST',
    '@game/FETCH_LEVEL_SUCCESS',
    '@game/FETCH_LEVEL_FAILURE')<void, ILevelGameState, ErrorResponse>();

export const fetchCategories = createAsyncAction(
    '@game/FETCH_CATEGORIES_REQUEST',
    '@game/FETCH_CATEGORIES_SUCCESS',
    '@game/FETCH_CATEGORIES_FAILURE')<void, Record<number, ICategory>, ErrorResponse>();

export const fetchQuestions = createAsyncAction(
    '@game/FETCH_QUESTIONS_REQUEST',
    '@game/FETCH_QUESTIONS_SUCCESS',
    '@game/FETCH_QUESTIONS_FAILURE')<void, Partial<ILevelGameState>, ErrorResponse>();

export const updateDailyStreak = createStandardAction("@game/UPDATE_DAILY_STREAK")<number>();